<!--
 * @Description: 备忘录 详情
 * @Author: ZSC
 * @Date: 2023-05-09 11:00:48.155
 * @LastEditors: PF
 * @LastEditTime: 2024-08-30 16:42:08
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="创建时间" label-align="right" align="left" width="100px" span="2">{{ruleForm.cjsj}}</el-descriptions-item>
        <el-descriptions-item label="标题" label-align="right" align="left" span="2">{{ruleForm.bt}}</el-descriptions-item>
        <el-descriptions-item label="类型" label-align="right" align="left" span="2">
          <div v-for="(item, index) in bwllxData" :key="index">
            <span v-if="ruleForm.lx == item.value">{{item.name}}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="开始时间" label-align="right" align="left" span="2">{{ruleForm.kssj}}</el-descriptions-item>
        <el-descriptions-item label="结束时间 " label-align="right" align="left" span="2">{{ruleForm.jssj}}</el-descriptions-item>
        <el-descriptions-item label="内容" label-align="right" align="left" span="2">{{ruleForm.nr}}</el-descriptions-item>

      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])
const bwllxData = ref()
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({
        url: '/api/v2/bangong/beiwanglu/beiwangluleixing',
        data: bwllxData
      })
      loadData({
        url: '/api/v2/bangong/beiwanglu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
